import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FileUploadsDisplay_List.html?raw';
import FileUploadDisplay_ListRow from '../FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import "../FileUploadDisplay_ListRow/FileUploadDisplay_ListRow";
import { FileUploadTypes } from "../FileUploadTypes";
import _WidgetBaseSP from 'more/_WidgetBaseSP';




class FileUploadsDisplay_List extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private rowContainer: HTMLElement;

    private _uploadsRegistry: Record<string, { rowWidget: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, fileData: FileUploadTypes.FileData, uploadGUID: string }>;


    clearRows(targetKey?: string): void {

        if (!this._uploadsRegistry) this._uploadsRegistry = {};

        for (let key in this._uploadsRegistry) {
            if (key == targetKey || !targetKey) {
                try {

                    let reg = this._uploadsRegistry[key];
                    reg.rowWidget.destroy();
                    this._uploadsRegistry[key] = null;

                } catch (ex) {

                }

                delete this._uploadsRegistry[key];

                if (targetKey) break;
            }
        }
        
        
        

        if (!targetKey) {
            this._uploadsRegistry = {}; // alles entfernt!
            this.UiModder.domConstruct.empty(this.rowContainer);
        }
    }

    setData(uploadsData: Array<FileUploadTypes.UploadUnit>, removeUnknownRows?: boolean): Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>> {
        let newRows: Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>> = [];

        let currentKeys = Object.keys(this._uploadsRegistry);

        let newKeys: Array<string> = [];
        if (uploadsData.length) {

            for (let unit of uploadsData) {
                let result = this.addUploadUnit(unit);
                if (result) {
                    newRows = newRows.concat(result);
                }

                // außerdem die neuen Keys in der Registry mitschneiden!
                for (let filedesc of unit.files) {
                    newKeys.push(filedesc.FileGUID);
                }
            }
        }

        if (removeUnknownRows === true) {
            for (let key of currentKeys) {
                if (newKeys.indexOf(key) == -1) {
                    this.clearRows(key)
                }
            }
        }

        return newRows;
    }


    displayRows(uploadsData: Array<FileUploadTypes.UploadUnit>): Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>> {

        //this.clearRows();

        return this.setData(uploadsData);
    }

    addUploadUnit(uploadUnit: FileUploadTypes.UploadUnit): Array<MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>> {
        if (!uploadUnit) return;

        let newRows = [];
        for (let file of uploadUnit.files) {
            let row = this.addFileRow(file, uploadUnit);
            if (row) newRows.push(row);
        }

        return newRows;
    }

    private addFileRow(fileDescriptor: FileUploadTypes.FileData, parentUnit: FileUploadTypes.UploadUnit): MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>> {

        if (!fileDescriptor || !parentUnit) return null;
        let key = fileDescriptor.FileGUID;

        if (this._uploadsRegistry[key] != null) return null;
        if (fileDescriptor.removed) return null;

        let row = new FileUploadDisplay_ListRow();
        row.setData(fileDescriptor, parentUnit.guid);
        row.placeAt(this.rowContainer);

        row.on('fileRemoved', lang.hitch(this, this._onFileRemoved));
        row.on('fileRemove_error', lang.hitch(this, this._onFileRemove_error));


        //topic.publish("FileUploadDisplay/NewRowCreated", { name: "createFileNewRow", row: row });
        this.emit("NewRowCreated", { name: "createFileNewRow", row: row });

        this._uploadsRegistry[key] = { fileData: fileDescriptor, rowWidget: row, uploadGUID: parentUnit.guid };

        return row;
    }

    
    getListEntry(targetGUID: string, filename?: string): MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>> {
        for (let key in this._uploadsRegistry) {
            let reg = this._uploadsRegistry[key];
            if (key == targetGUID || (reg.fileData.FileName == filename && reg.uploadGUID == targetGUID)) {
                return reg?.rowWidget;
            }
        }

        return null;
    }

    private _onFileRemoved(file: FileUploadTypes.UploadDescriptor) {
        let key = file.FileGUID;
        if (this._uploadsRegistry[key]) {
            this.clearRows(key);
        }
        this.emit("fileRemoved", file);

        
    }

    private _onFileRemove_error(error?: object): void {
        this.emit("fileRemove_error", error);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        
        this._uploadsRegistry = {};
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        //this.inherited(arguments);

    }
}

export default mdsWidget(FileUploadsDisplay_List);